export default __webpack_public_path__ + "static/Lazada1-48c75ad1aae3e0dcf907a19eb5d20e2b.jpg";